import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      color: "white",
    },
    "& label": {
      color: "white",
    },
    "& label.Mui-focused": {
      color: "white",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "yellow",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "white",
      },
      "&:hover fieldset": {
        borderColor: "white",
      },
      "&.Mui-focused fieldset": {
        borderColor: "yellow",
      },
    },
  },
  paper: {
    backgroundColor: "hsla(245, 100%, 30%, .9)",
    padding: theme.spacing(2),
    borderRadius: 30,
  },
  form: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    color: "wheat",
  },
  fileInput: {
    width: "97%",
    margin: "10px 0",
  },
  TextField: {
    color: "white",
  },
  multilineColor: {
    color: "white",
    borderRadius: 10,
  },
  buttonSubmit: {
    marginBottom: 10,
    color: "white",
    backgroundColor: "hsla(161, 100%, 30%, 1)",
    "&:hover": {
      background: "hsla(161, 100%, 30%, 1)",
      filter: "brightness(1.5)",
    },
    width: "16.9em",
    height: "2.4em",
    borderRadius: "2em",
  },
  buttonClear: {
    position: "relative",
    width: "14.6em",
    borderRadius: "2em",
    backgroundColor: "hsla(319, 100%, 56%, 0.92)",
    "&:hover": {
      background: "maroon",
    },
  },
}));
